import React, { FC } from 'react';
import useDocumentFeesModal from './document-modal-calculation-hooks';
import DocumentModalCalculationScene from './document-modal-calculation-scene';

type modalCalculationFeesProps = {
  open: boolean;
  onClose: () => void;
  letter: string;
  documentAccountingId?: string;
  documentDescription?: string;
};

const DocumentCalculationModal: FC<modalCalculationFeesProps> = ({
  open,
  onClose,
  letter,
  documentAccountingId,
  documentDescription,
}) => {
  const { methods, handleEntry, responseAddManualcharge, createErrors } = useDocumentFeesModal({
    onClose,
    letter,
    documentAccountingId,
    documentDescription,
  });

  return (
    <DocumentModalCalculationScene
      open={open}
      onClose={onClose}
      methods={methods}
      handleEntry={handleEntry}
      loading={responseAddManualcharge.isLoading}
      errors={createErrors}
      isEditing={documentAccountingId !== undefined}
    />
  );
};

export default DocumentCalculationModal;
